import React, { useCallback, useEffect, useState } from "react";
import { useCompany } from "../../context/CompanyContext";
import { getCrmForecastSummary } from "../services/crmForecastService";
import "../styles/crm.css";

const CRMForecastPage = () => {
  const { companyId } = useCompany();
  const [rows, setRows] = useState([]);
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);

  const load = useCallback(async () => {
    if (!companyId) {
      return;
    }

    setLoading(true);
    setMessage("");

    try {
      const data = await getCrmForecastSummary(companyId);
      setRows(data);
    } catch (error) {
      setMessage(error.message || "Failed to load CRM forecast");
    } finally {
      setLoading(false);
    }
  }, [companyId]);

  useEffect(() => {
    load();
  }, [load]);

  return (
    <div>
      <h2 className="crm-page-title">CRM Forecast</h2>

      {message ? <div className="crm-message">{message}</div> : null}

      {loading ? (
        <div className="crm-message">Loading forecast...</div>
      ) : rows.length === 0 ? (
        <div className="crm-message">No forecast data found.</div>
      ) : (
        <div className="crm-table-card">
          <div className="crm-data-table-wrap">
            <table className="crm-data-table">
              <thead>
                <tr>
                  <th>Period</th>
                  <th>Pipeline</th>
                  <th>Weighted</th>
                  <th>Committed</th>
                  <th>Won</th>
                </tr>
              </thead>
              <tbody>
                {rows.map((row) => (
                  <tr key={row.period}>
                    <td>{row.period}</td>
                    <td>₦{Number(row.pipeline || 0).toLocaleString()}</td>
                    <td>₦{Number(row.weighted || 0).toLocaleString()}</td>
                    <td>₦{Number(row.committed || 0).toLocaleString()}</td>
                    <td>₦{Number(row.won || 0).toLocaleString()}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </div>
  );
};

export default CRMForecastPage;
